import React from "react";
import {Draggable} from "react-beautiful-dnd";
import {FaArrowsAlt} from "react-icons/all";
import {_at} from "../AT";


const DragAndDropItem = ({component, index, draggableId, dropInfo}) => {
    return (
        <Draggable draggableId={draggableId} index={index}>
            {(provided, snapshot) => (
                <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                    <div className={"shadow-sm rounded mb-5 mt-0 border border-grey-700"}>
                        <div className="px-5 py-2 w-full border-b border-grey-500 grid grid-cols-3 items-center">

                        <div className={"text-left"}>
                                {component.headerLeft}
                            </div>
                            <div className={"text-center items-center justify-center"}>
                                <div className={"flex flex-row items-center px-3"}>
                                    <FaArrowsAlt/>
                                    <span className={"italic ml-2"}>{dropInfo?dropInfo:_at("Přetažením změníte pořadí")}</span>
                                </div>

                            </div>
                            <div className={"text-right"}>
                                {component.headerRight}
                            </div>
                        </div>
                        <div className={"w-full px-5"}>
                            {component.content}
                        </div>

                    </div>
                </div>
            )}
        </Draggable>
    )

}
export default DragAndDropItem;
